import React, { useState, useEffect, Component } from "react";
import { ModalContext } from "../App.js";
import { ModalStyles } from "../styles";
import { useStitchAuth } from "../StitchAuth.js";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

export default function Modal() {
  const [modalMode, setModalMode] = useState("loginMode");
  const { isLoggedIn, currentUser, actions, loginErrors } = useStitchAuth();
  let history = useHistory();
  return (
    <ModalContext.Consumer>
      {({ isModalShowing, toggleModal }) => (
        <div style={isModalShowing ? {} : { opacity: 0, visibility: "hidden" }}>
          <div id="LoginModalOuter">
            <div id="LoginModalInner">
              <ModalInner
                isModalShowing={isModalShowing}
                toggleModal={toggleModal}
                isLoggedIn={isLoggedIn}
                handleEmailLogin={actions.handleEmailLogin}
                handleLogin={actions.handleLogin}
                handleEmailRegister={actions.handleEmailRegister}
                sendResetPasswordEmail={actions.sendResetPasswordEmail}
                loginErrors={loginErrors}
                userType={currentUser ? currentUser.loggedInProviderName : null}
                history={history}
              />
            </div>
          </div>
        </div>
      )}
    </ModalContext.Consumer>
  );
}

class ModalInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      password1: "",
      password2: "",
      modalMode: "loginMode",
      registerError: "",
      registerLoading: false,
      loginLoading: false,
      forgotLoading: false,
      forgotError: "",
    };
  }

  forgotPassword = () => {
    if (this.state.forgotLoading) {
      return;
    }

    this.setState({ forgotLoading: true });
    this.props.sendResetPasswordEmail(this.state.email).then((result) => {
      this.setState({ forgotLoading: false });
      if (result === "success") {
        this.setState({ modalMode: "forgotSuccessMode" });
      } else {
        this.setState({ forgotError: result.message });
      }
    });
  };

  registerWithEmail = () => {
    if (this.state.registerLoading) {
      return;
    }

    //accessing methods in stitchauth.js to access authentication js...
    this.setState({ registerLoading: true });
    this.props
      .handleEmailRegister({
        username: this.state.username,
        email: this.state.email,
        password1: this.state.password1,
      })
      .then((result) => {
        if (result === "success") {
          this.setState({ modalMode: "verifyMode", registerLoading: false });
        } else {
          this.setState({
            registerError:
              result.message === "name already in use"
                ? "Email already used"
                : result.message,
            registerLoading: false,
          });
        }
      });
  };

  componentDidUpdate(prevProps) {
    // if we got errors, that means we aren't in loading anymore
    if (this.props.loginErrors !== prevProps.loginErrors) {
      this.setState({ loginLoading: false });
    }

    // if we just successfully logged in as email, close modal
    if (this.props.isLoggedIn && !prevProps.isLoggedIn) {
      if (this.props.userType !== "oauth2-google") {
        this.props.toggleModal();
      }
      this.setState({ email: "", password1: "", loginLoading: false });
    }

    // if we closed modal, open it as a blank loginModal when we reopen
    if (!this.props.isModalShowing && prevProps.isModalShowing) {
      console.log(this.props.isModalShowing);
      this.setState({ modalMode: "loginMode" });
    }

    if (this.props.registerSuccess && !prevProps.registerSuccess) {
      console.log(
        "go to screen saying open up email to verify & go back to login screen"
      );

      //it's okay to
    }
  }

  handleInputChange = (event) => {
    this.setState({ [event.target.id]: event.target.value }, () => {});
  };

  handleGoogleLogin = () => {
    if (this.state.loginLoading) {
      return;
    }
    this.props.handleLogin("google");
  };

  handleEmailLogin = () => {
    if (this.state.loginLoading) {
      return;
    }

    this.setState({ loginLoading: true });

    this.props.handleEmailLogin({
      email: this.state.email,
      password: this.state.password1,
    });
  };

  goToCreateScreen = () => {
    this.setState({
      modalMode: "createMode",
      email: "",
      password1: "",
      password2: "",
      username: "",
    });
  };

  goToLoginScreen = (from) => {
    this.setState({ modalMode: "loginMode" });
    this.setState({
      email: from === "createScreen" ? "" : this.state.email,
      password1: "",
      password2: "",
      username: "",
    });
  };

  goToForgotScreen = () => {
    this.setState({
      modalMode: "forgotMode",

      password1: "",
      password2: "",
      username: "",
    });
  };

  render() {
    const mode = this.state.modalMode;
    if (this.props.isLoggedIn) return null;
    switch (mode) {
      case "loginMode":
        return (
          <div>
            {this.props.loginErrors.message}
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                placeholder="Email"
                id="email"
                onChange={this.handleInputChange}
                value={this.state.email}
              />
            </div>
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                resizable="false"
                placeholder="Password"
                id="password1"
                onChange={this.handleInputChange}
                value={this.state.password1}
              />
            </div>
            <div className="LoginButtonContainer">
              <span
                className={
                  this.state.loginLoading
                    ? "LoginButton Loading"
                    : "LoginButton"
                }
                onClick={this.handleEmailLogin}
              >
                Login
              </span>
            </div>
            <div>Or</div>
            <div className="GoogleButtonOuter" onClick={this.handleGoogleLogin}>
              <div className="GoogleButtonInner">
                <a>
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18px"
                    height="18px"
                    viewBox="0 0 48 48"
                    className="googleIcon"
                  >
                    <g>
                      <path
                        fill="#EA4335"
                        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                      ></path>
                      <path
                        fill="#4285F4"
                        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                      ></path>
                      <path
                        fill="#FBBC05"
                        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                      ></path>
                      <path
                        fill="#34A853"
                        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                      ></path>
                      <path fill="none" d="M0 0h48v48H0z"></path>
                    </g>
                  </svg>
                </a>
                <a>Sign in with Google</a>
              </div>
            </div>
            <div className="BottomText" onClick={this.goToCreateScreen}>
              Create Account
            </div>
            <div className="BottomText" onClick={this.goToForgotScreen}>
              Forgot Password?
            </div>
          </div>
        );
      case "createMode":
        return (
          <div>
            {this.state.registerError}
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                placeholder="Email"
                id="email"
                onChange={this.handleInputChange}
                value={this.state.email}
              />
            </div>
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                placeholder="Password"
                id="password1"
                onChange={this.handleInputChange}
                value={this.state.password1}
              />
            </div>
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                placeholder="Verify Password"
                id="password2"
                onChange={this.handleInputChange}
                value={this.state.password2}
              />
            </div>
            <div className="LoginButtonContainer">
              <span
                className={
                  this.state.registerLoading
                    ? "LoginButton Loading"
                    : "LoginButton"
                }
                onClick={this.registerWithEmail}
              >
                Create & Send Verification Email
              </span>
            </div>
            <div
              onClick={() => {
                this.goToLoginScreen("createScreen");
              }}
              className="BottomText"
            >
              Take me back to login
            </div>
          </div>
        );

      case "forgotMode":
        return (
          <div>
            {this.state.forgotError}
            <div className="LoginFieldContainer">
              <input
                className="LoginInput"
                placeholder="Email associated"
                value={this.state.email}
                onChange={this.handleInputChange}
                id="email"
              />
            </div>
            <div className="LoginButtonContainer">
              <span
                className={
                  this.state.forgotLoading
                    ? "LoginButton Loading"
                    : "LoginButton"
                }
                onClick={this.forgotPassword}
              >
                Send password reset function to email
              </span>
            </div>
            <div
              onClick={() => {
                this.goToLoginScreen("verifyScreen");
              }}
              className="BottomText"
            >
              Take me back to login
            </div>
          </div>
        );
      case "verifyMode":
        return (
          <div>
            <div style={{ marginBottom: "1.5rem" }}>
              Verification Email sent! Email expires after 2 hours
            </div>
            <a
              onClick={(event) => {
                window.location.href = "/confirmEmail";
              }}
              style={{
                textDecoration: "underline",
                color: "blue",
                cursor: "pointer",
              }}
            >
              Didn't receive email?
            </a>
            <div onClick={this.goToLoginScreen} className="BottomText">
              Take me back to login
            </div>
          </div>
        );
      case "forgotSuccessMode":
        return (
          <div>
            <div style={{ color: "black" }}>
              Successfully sent! Link will expire in 30 minutes
            </div>
            <div
              onClick={() => {
                this.goToLoginScreen("verifyScreen");
              }}
              className="BottomText"
            >
              Take me back to login
            </div>
          </div>
        );

      default:
        return null;
    }
  }
}
